import { apiRequest } from '../config/api';

type CdnFilesResponse = {
  files: Array<{ name: string }>;
};

const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.webp'];

function isImageFile(name: string): boolean {
  const lower = name.toLowerCase();
  return IMAGE_EXTENSIONS.some((ext) => lower.endsWith(ext));
}

export type RegionBackgroundOption = {
  value: string;
  label: string;
};

/** S3 / CDN folder prefix (matches public app `/images/region-backgrounds/...`). */
export const REGION_BACKGROUND_CDN_FOLDER = 'region-backgrounds';

/**
 * Lists image files under region-backgrounds/{regionSlug}/ for the region edit modal.
 * Values are "{slug}/{filename}" for storage in region_background.
 */
export async function fetchRegionBackgroundCdnOptions(
  token: string,
  regionSlug: string | undefined
): Promise<RegionBackgroundOption[]> {
  const slug = regionSlug?.trim();
  if (!slug) {
    return [];
  }
  const folderParam = `${REGION_BACKGROUND_CDN_FOLDER}/${slug}/`;
  const res = await apiRequest<CdnFilesResponse>(
    `/admin/cdn/files?folder=${encodeURIComponent(folderParam)}`,
    token
  );
  const out: RegionBackgroundOption[] = [];
  for (const file of res.files || []) {
    if (!isImageFile(file.name)) continue;
    out.push({
      value: `${slug}/${file.name}`,
      label: file.name,
    });
  }
  out.sort((a, b) => a.value.localeCompare(b.value));
  return out;
}
